import { createContext } from "react";

const noteAppcontext=createContext()
export default noteAppcontext